import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const InversionSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Inversión
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
        MVP (Fase 1)
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Box
            component={Card}
            sx={{
              bgcolor: theme.palette.primary.main,
              color: theme.palette.common.white,
              borderLeft: 4,
              borderColor: theme.palette.primary.dark,
            }}
          >
            <CardContent sx={{ py: 4 }}>
              <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                  Costo total MVP (Fase 1)
                </Typography>
                <Typography variant="h2" fontWeight={900} sx={{ color: theme.palette.common.white }}>
                  $1,790 USD
                </Typography>
              </Box>
              <Box mt={3} pt={3} sx={{ borderTop: '1px solid rgba(255,255,255,0.3)' }}>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ color: theme.palette.common.white }}>
                  Forma de pago:
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)' }}>
                  • 30% para empezar
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)' }}>
                  • 20% con el primer prototipo (2 semanas)
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)' }}>
                  • 50% a la entrega y despliegue
                </Typography>
              </Box>
            </CardContent>
          </Box>
        </Grid>
      </Grid>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InversionSection;
